import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { header, urgentDate, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	editor: {
		display: 'flex',
		flexDirection: 'column',
		// Viewport minus the app bar (124px) and the flyout's own header (49px), matching the
		// read-view container height so edit/read stay the same size.
		height: 'calc(100vh - 124px - 49px)',
	},
	body: {
		flex: 1,
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	fields: {
		display: 'flex',
		flexDirection: 'column',
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		':not(:last-child)': {
			borderBottom: `1px solid ${THEME.colors.border.light}`,
		},
	},
	sectionLabel: {
		color: header,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		textTransform: 'uppercase',
		letterSpacing: 0.5,
	},
	editorRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
	},
	editor_input: {
		flex: 1,
		minWidth: 0,
	},
	detailRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: THEME.spacing.md,
		minHeight: 32,
	},
	label: {
		color: header,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		flexShrink: 0,
	},
	control: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		minWidth: 0,
		justifyContent: 'flex-end',
	},
	controlValue: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		whiteSpace: 'nowrap',
	},
	controlPlaceholder: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.primary.main,
		whiteSpace: 'nowrap',
	},
	removeButton: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 20,
		height: 20,
		minWidth: 20,
		padding: 0,
		borderRadius: '50%',
		color: header,
		fontSize: THEME.typography.fontSizes.md,
		lineHeight: 1,
	},
	loading: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.md,
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		borderTop: THEME.common.border,
		background: white,
	},
	deleteButton: {
		marginLeft: 'auto',
		color: urgentDate,
	},
});
